import { Reducer } from 'redux';
import { SessionActionTypes, SessionState } from './types';

const initialState: SessionState = {
  alerts: [],
  notifications: [],
  initial: false,
  session: false,
  authenticing: false,
  currentUser: {},
  isAuthenticated: false,
  mailboxUnmatchedCount: 0,
  isMaintenance: false,
  isShowHideTriggered: false,
  showOrganisationSuspendedModal: false,
  isEnvVar: false,
  appConfig: null
};

const reducer: Reducer<SessionState> = (state = initialState, action: any) => {
  switch (action.type) {
    case SessionActionTypes.SESSION_START: {
      return {
        ...state,
        session: true,
        sessionExpiryIn: action.payload || undefined
      };
    }
    case SessionActionTypes.SET_USER_SESSION: {
      const { role_type, is_trial } = action.payload;
      const { currentUser } = state;
      const role_type_actual =
        role_type === 'User' && is_trial ? 'Trial User' : role_type;

      const currentUserData = {
        ...currentUser,
        ...action.payload,
        role_type_actual
      };

      return {
        ...state,
        currentUser: currentUserData,
        isAuthenticated: true,
        session: true
      };
    }
    // SET_AUTHENTICATED
    case SessionActionTypes.SET_AUTHENTICATED: {
      return {
        ...state,
        isAuthenticated: action.payload
      };
    }
    case SessionActionTypes.SET_SCREEN_SIZE: {
      return {
        ...state,
        screenSize: action.payload
      };
    }
    case SessionActionTypes.SET_BASE_MAP:
      return {
        ...state,
        baseMap: action.payload
      };
    case SessionActionTypes.SET_ACTIVATE_IDLE:
      return {
        ...state,
        activateIdle: action.payload
      };
    case SessionActionTypes.SET_SYSADMIN_MODE:
      return {
        ...state,
        isSysAdminMode: action.payload
      };
    case SessionActionTypes.SESSION_END: {
      return {
        ...initialState,
        session: false,
        isAuthenticated: false,
        currentUser: {},
        screenSize: state?.screenSize
      };
    }
    case SessionActionTypes.FETCH_USER_START: {
      return {
        ...state,
        userProcess: action.payload?.process || 'loading'
      };
    }
    case SessionActionTypes.FETCH_USER_SUCCESS: {
      return {
        ...state,
        initial: true,
        userProcess: undefined
      };
    }
    case SessionActionTypes.FETCH_USER_FAILURE: {
      return {
        ...state,
        initial: true,
        userProcess: undefined
      };
    }
    case SessionActionTypes.UPDATE_USER_START: {
      return {
        ...state,
        userProcess: 'updating'
      };
    }
    case SessionActionTypes.UPDATE_USER_SUCCESS: {
      return {
        ...state,
        userProcess: undefined
      };
    }
    case SessionActionTypes.UPDATE_USER_FAILURE: {
      return {
        ...state,
        userProcess: undefined
      };
    }
    case SessionActionTypes.AUTHENTICATION_START: {
      return {
        ...state,
        authenticing: true
      };
    }
    case SessionActionTypes.AUTHENTICATION_SUCCESS: {
      return {
        ...state,
        authenticing: false
      };
    }
    case SessionActionTypes.AUTHENTICATION_FAILURE: {
      return {
        ...state,
        authenticing: false,
        authError: action.payload
      };
    }
    case SessionActionTypes.ADD_ALERT:
      return {
        ...state,
        alerts: [...state.alerts, action.payload]
      };
    case SessionActionTypes.REMOVE_ALERT:
      return {
        ...state,
        alerts: state.alerts.filter((alert) => alert.id !== action.payload)
      };
    case SessionActionTypes.REMOVE_ALL_ALERTS:
      return {
        ...state,
        // only remove all alerts if the action.payload is true
        alerts: action.payload
          ? []
          : state.alerts.filter((alert) => alert.isSystemAlert === true)
      };
    case SessionActionTypes.ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.payload]
      };
    case SessionActionTypes.REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.id !== action.payload
        )
      };
    case SessionActionTypes.MAILBOX_UNMATCHED_COUNT_START: {
      return {
        ...state
      };
    }
    case SessionActionTypes.MAILBOX_UNMATCHED_COUNT_SUCCESS: {
      return {
        ...state,
        mailboxUnmatchedCount: action.payload.count
      };
    }
    case SessionActionTypes.MAILBOX_UNMATCHED_COUNT_FAILURE: {
      return {
        ...state,
        mailboxUnmatchedCount: 0
      };
    }
    case SessionActionTypes.LOAD_CUSTOM_BASEMAP_START: {
      return {
        ...state,
        customBaseMap: undefined
      };
    }
    case SessionActionTypes.LOAD_CUSTOM_BASEMAP_SUCCESS: {
      return {
        ...state,
        customBaseMap: action.payload
      };
    }
    case SessionActionTypes.LOAD_CUSTOM_BASEMAP_FAILURE: {
      return {
        ...state,
        customBaseMap: action.payload
      };
    }
    case SessionActionTypes.SET_MAINTENANCE: {
      return {
        ...state,
        isMaintenance: true
      };
    }
    case SessionActionTypes.TOGGLE_SHOW_HIDE: {
      return {
        ...state,
        isShowHideTriggered: !state.isShowHideTriggered
      };
    }
    case SessionActionTypes.SHOW_ORGANISATION_SUSPENDED_MODAL: {
      return {
        ...state,
        showOrganisationSuspendedModal: action.payload
      };
    }
    case SessionActionTypes.FETCH_ALERT_NOTIFICATION_STATUS_SUCCESS: {
      const parsedValue = action.payload?.value
        ? JSON.parse(action.payload.value)
        : {};
      return {
        ...state,
        appConfig: {
          ...action.payload,
          parsedValue
        }
      };
    }
    default:
      return state;
  }
};

export { reducer as SessionReducer };
